import { useState } from "react";
import { DateRangeResponse } from "../../../utils/DateRangePicker/DateRangePicker.type";
import { TModalProps } from "./Table.type";
import { DateRangePicker } from "../../../utils/DateRangePicker";

export default function Table({
  data,
  currentPage,
  totalElements,
  columns,
  enableAdd,
  requestAdd,
  addOnClick,
  disableToolbar,
  customToolbarButtons,
  enableBulkDelete,
  DateRangeFilter,
  DateRangeOnChange,
  bulkDeleteOnClick,
  disableSearch,
  disableMultiSelect,
  disableSelectAll,
  onMultiSelectChange,
  onChangePage,
  onChangeRowsPerPage,
  isLoading,
  isDisabled,
  triggerErrorMessage,
  downloadReport,
  containerStyles,
  enableReportButton,
  enablePagination = true,
  maxHeight,
  searchWidth
}: TModalProps) {
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allSelected, setAllSelected] = useState(false);

  const filteredData = data?.filter((row: any) =>
    columns.some((col: any) =>
      String(row[col.field] || "").toLowerCase().includes(searchTerm.toLowerCase())
    )
  ) || [];

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedRows([]);
      setAllSelected(false);
    } else {
      setSelectedRows(filteredData);
      setAllSelected(true);
    }
    onMultiSelectChange && onMultiSelectChange(allSelected ? [] : filteredData);
  };

  const handleRowSelect = (row: any) => {
    const isSelected = selectedRows.some(selected => selected === row);
    let newSelected;

    if (isSelected) {
      newSelected = selectedRows.filter(selected => selected !== row);
    } else {
      newSelected = [...selectedRows, row];
    }

    setSelectedRows(newSelected);
    setAllSelected(newSelected.length === filteredData.length);
    onMultiSelectChange && onMultiSelectChange(newSelected);
  };

  return (
    <div className={`modern-table-container ${containerStyles || ""}`}>
      {/* Toolbar */}
      {!disableToolbar && (
        <div className="table-toolbar">
          <div className="toolbar-left">
            {!disableSearch && (
              <div className="search-container">
                <input
                  type="text"
                  placeholder="Buscar..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
              </div>
            )}
          </div>

          <div className="toolbar-right">
            {customToolbarButtons}

            {enableBulkDelete && selectedRows.length > 0 && (
              <button
                className="btn btn-delete"
                onClick={() => bulkDeleteOnClick && bulkDeleteOnClick(null, selectedRows)}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 011.334-1.334h2.666a1.333 1.333 0 011.334 1.334V4m2 0v9.333a1.333 1.333 0 01-1.333 1.334H4.667a1.333 1.333 0 01-1.334-1.334V4h9.334zM6.667 7.333v4M9.333 7.333v4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Eliminar ({selectedRows.length})
              </button>
            )}

            {DateRangeFilter && (
              <DateRangePicker
                onChange={(update: DateRangeResponse) =>
                  DateRangeOnChange && DateRangeOnChange(update)
                }
              />
            )}

            {enableReportButton && (
              <button
                className="btn btn-report"
                onClick={() => downloadReport?.()}
                title="Descargar Reporte"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M14 10v2.667A1.333 1.333 0 0112.667 14H3.333A1.333 1.333 0 012 12.667V10M8 10.667L8 2M8 10.667l-2.667-2.666M8 10.667l2.667-2.666" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            )}

            {enableAdd && (
              <button
                className="btn btn-primary"
                onClick={() => addOnClick && addOnClick()}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 3.333v9.334M3.333 8h9.334" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Agregar
              </button>
            )}

            {requestAdd && (
              <button
                className="btn btn-primary"
                onClick={() => addOnClick && addOnClick()}
              >
                Nueva Solicitud
              </button>
            )}
          </div>
        </div>
      )}

      {/* Table */}
      <div className="table-wrapper" style={{ maxHeight }}>
        {isLoading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Cargando...</p>
          </div>
        ) : (
          <table className="modern-table">
            <thead>
              <tr>
                {!disableMultiSelect && (
                  <th className="checkbox-column">
                    {!disableSelectAll && (
                      <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={handleSelectAll}
                        className="table-checkbox"
                      />
                    )}
                  </th>
                )}
                {columns.map((column: any, index: number) => (
                  <th key={index} className="table-header">
                    {column.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan={columns.length + (!disableMultiSelect ? 1 : 0)} className="empty-cell">
                    <div className="empty-content text-center">
                      <p>Momentáneamente no hay registros cargados para mostrar.</p>
                    </div>
                  </td>
                </tr>
              ) : (
                filteredData.slice(0, rowsPerPage).map((row: any, rowIndex: number) => (
                  <tr key={rowIndex} className="table-row">
                    {!disableMultiSelect && (
                      <td className="checkbox-column">
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(row)}
                          onChange={() => handleRowSelect(row)}
                          disabled={isDisabled && isDisabled(row)}
                          className="table-checkbox"
                          onClick={(e) => {
                            if (isDisabled && isDisabled(row)) {
                              e.preventDefault();
                              triggerErrorMessage && triggerErrorMessage();
                            }
                          }}
                        />
                      </td>
                    )}
                    {columns.map((column: any, colIndex: number) => (
                      <td key={colIndex} className="table-cell">
                        {column.render ? column.render(row[column.field], row) : (row[column.field] || "-")}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      {enablePagination && filteredData.length > 0 && (
        <div className="table-pagination">
          <div className="pagination-info">
            Mostrando {Math.min(rowsPerPage, filteredData.length)} de {filteredData.length} registros
          </div>
          <div className="pagination-controls">
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                onChangeRowsPerPage && onChangeRowsPerPage(Number(e.target.value));
              }}
              className="rows-select"
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <span className="pagination-label">por página</span>
          </div>
        </div>
      )}
    </div>
  );
}